import { EventTicket } from 'src/modules/event/models/eventTicket';
import AxiosInstance from './axios/interceptor';

const controller = 'EventTicket';

export const getAllEventTicketsByEventId = (eventId: number) => {
  const endpoint = `${controller}/EventId/${eventId}`;
  return AxiosInstance.get<EventTicket[]>(endpoint);
};

export const disableEventTicket = (id: number) => {
  const endpoint = `${controller}/${id}/Disable`;
  return AxiosInstance.put<EventTicket>(endpoint);
};

export const enableEventTicket = (id: number) => {
  const endpoint = `${controller}/${id}/Enable`;
  return AxiosInstance.put<EventTicket>(endpoint);
};
